 import {RouterModule, Routes} from '@angular/router';
 const ROUTES: Routes = [
  {path: 'admin/reset-password', loadChildren: 'app/module/login-operation/reset-password/reset-password.module#ResetPasswordModule'},
  // {path: 'nurse/reset-password', loadChildren: 'app/module/login-operation/reset-password/reset-password.module#ResetPasswordModule'},
  {path: 'admin/login', loadChildren: 'app/module/login-operation/login-admin/login-admin.module#LoginAdminModule'},
  // {path: 'nurse/login', loadChildren: 'app/module/login-operation/login-nurse/login-nurse.module#LoginNurseModule'},
  // {path: 'user/login', loadChildren: 'app/module/login-operation/login-user/login-user.module#LoginUserModule'},
  {path: '', loadChildren: 'app/module/index-operation/index-operation.module#IndexOperationModule'},
  {path: '**', redirectTo: 'admin/login', pathMatch: 'full'}
];
 export const ROOT_ROUTING = RouterModule.forRoot(ROUTES);



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/bw.routing.ts